<template>
    <div>

        <headline>
            Einladungen
            <template v-slot:more>
                <confirm-dialog @confirmed="inviteAll" class="mr-2">
                    <template v-slot:header>Alle Nutzer einladen</template>
                    <template v-slot:question>
                        Soll eine Einladungsemail an alle Nutzer geschickt werden?
                    </template>
                    <template v-slot:confirm>
                        <button-secondary>
                            E-Mail an Alle schicken
                        </button-secondary>
                    </template>
                    <button-secondary>
                        Alle einladen
                    </button-secondary>
                </confirm-dialog>
                <user-invite-upload @reload="load" class=""></user-invite-upload>
                <user-invite class="" @reload="load">Benutzer einladen</user-invite> 
            </template>
        </headline>

        <loading v-show="loading"></loading>

        <tailwind-table class="mb-8" v-show="invitees.length > 0" :header="['E-Mail', 'Eingeladen am', '']">
            <user-invite-single
                :key="invitee.id"
                :invitee="invitee" v-for="(invitee, i) in invitees"
                @reload="load"
                :class="{'bg-white': i % 2 === 0, 'bg-gray-50' : i % 2 !== 0}"></user-invite-single>
        </tailwind-table>

        <p v-show="invitees.length === 0" class="">
            Keine offenen Einladungen gefunden.
        </p>

    </div>
</template>

<script>
import TailwindTable from "../components/UI/TailwindTable";
import UserInvite from "../components/User/UserInvite";
import UserInviteUpload from "../components/User/UserInviteUpload.vue";
import UserInviteSingle from "../components/UserInviteSingle.vue";
import Headline from "../components/UI/Headline";
import Loading from "../components/UI/Loading.vue";
import ConfirmDialog from "../components/UI/ConfirmDialog.vue";
import ButtonSecondary from "../components/UI/ButtonSecondary.vue";

export default {
    name: "UserInvitees",

    components: {Loading, UserInviteSingle, UserInviteUpload, UserInvite, TailwindTable, Headline, ConfirmDialog, ButtonSecondary},

    //props: ['invitees', 'registered'],

    data: () => ({
        invitees: [],
        registered: [],
        loading: false,
    }),

    created() {
        this.load();
    },

    methods: {
        load() {
            this.loading = true;
            this.$http
                .get('/admin/user_invitees')
                .then(result => {
                    this.registered = result.data.registered;
                    this.invitees = result.data.invitees;
                    this.loading = false;
                })
                .catch(error => {
                    this.$root.$emit('error', error);
                    this.loading = false;
                });
        },
        inviteAll() {
            this.loading = true;
            this.$http.post(`/admin/user_invitees`, {
                invite_all: true,
            })
                .then(() => {
                    this.loading = false;
                    this.$root.$emit('alert', 'Alle Nutzer eingeladen.');
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                });
        },
    }
}
</script>

<style scoped>

</style>
